module.exports = __webpack_public_path__ + "static/media/15UN-Habitat7.e3767db9.jpg";